import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5635e646"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card__img" }
const _hoisted_2 = { class: "card__content" }
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "overlay", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "card__title",
            title: _ctx.title,
            onMousemove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, _toDisplayString(_ctx.title), 41, _hoisted_3))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}